import sample_01 from './outdoorReflect.jpg';

export const outdoorReflectImpressions = {
    sample_01,
};
